import PropTypes from 'prop-types';
import React from 'react';

import { Header, SideLine, Footer, Background } from '$partials/global/index.js';
import { ModuleDispatcher } from '$partials/modules';
import { getBackgroundColours } from '$utilities/site-context';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const HomePage = (props) => {
    const page = props.data.page;
    return (
        <>
            <Background {...getBackgroundColours()} />

            {/* Navigation */}
            <Header navigation={props.data.navigation}/>

            {/* Main content */}
            <main
                className='pt-40 sm:pt-50 md:pt-100 min-h-screen relative'
                id='main-content'>

                <SideLine/>

                <div className='layout-container'>
                    <div className='flex flex-wrap layout-negative-margin'>
                        {/* Heading */}
                        <div className='sm:w-11/12 md:w-10/12 layout-item-padding'>
                            <h1 className='type-style-1'>
                                {page?.heroTitle}
                            </h1>
                        </div>
                    </div>
                </div>

                {/* Spacer */}
                <div className='md:mt-20'/>

                {/* Module dispatcher */}
                {page.modules?.length > 0 &&
                    <section>
                        {page.modules.map((module, i, { length, ...modules }) => {
                            const isLast = length - 1 === i;
                            const nextModuleType = modules[i + 1]?.__typename;
                            const previousModuleType = modules[i - 1]?.__typename;
                            return (
                                <ModuleDispatcher
                                    {...module}
                                    isLast={isLast}
                                    key={i + module?.id}
                                    nextModuleType={nextModuleType}
                                    pageTypename={page.__typename}
                                    previousModuleType={previousModuleType}/>
                            );
                        })}
                    </section>
                }
            </main>


            {/* Footer */}
            {props.data?.footer && (
                <Footer {...props.data.footer}/>
            )}
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.shape({
            heroTitle: PropTypes.string,
            modules: PropTypes.array,
            __typename: PropTypes.string,
        }),
        navigation: PropTypes.object,
        footer: PropTypes.object,
    }),
    domain: PropTypes.string,
};

HomePage.propTypes = propTypes;

export default HomePage;
